import React from 'react';
import { PiArrowsClockwiseBold } from 'react-icons/pi';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { TranslateParams } from 'src/modules/shared/types/i18n/i18n.type';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

interface PropertySyncManagedNoticeProps {
  providerLabel: string;
  t: (key: TranslationKey, params?: TranslateParams) => string;
}

export const PropertySyncManagedNotice: React.FC<
  PropertySyncManagedNoticeProps
> = ({ providerLabel, t }) => {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-primary-100 bg-primary-50/60 px-3 py-2">
      <PiArrowsClockwiseBold className="mt-0.5 h-4 w-4 shrink-0 text-primary-700" />
      <div className="min-w-0">
        <Text size="small" weight="medium" className="text-slate-900">
          {t('catalog.properties.meli.currentPublication.syncManaged', {
            provider: providerLabel,
          })}
        </Text>
        <Text size="tiny" className="mt-0.5 text-slate-500">
          {t(
            'catalog.properties.meli.currentPublication.syncManagedDescription',
            {
              provider: providerLabel,
            }
          )}
        </Text>
      </div>
    </div>
  );
};
